"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BodyRow;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _classnames = _interopRequireDefault(require("classnames"));

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _Icons = require("../../atoms/Icons");

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function BodyRow(_ref) {
  var rowKey = _ref.id,
      _ref$rowClick = _ref.rowClick,
      rowClick = _ref$rowClick === void 0 ? _noop2.default : _ref$rowClick,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$removeItem = _ref.removeItem,
      removeItem = _ref$removeItem === void 0 ? false : _ref$removeItem,
      _ref$onRemoveItem = _ref.onRemoveItem,
      onRemoveItem = _ref$onRemoveItem === void 0 ? _noop2.default : _ref$onRemoveItem,
      _ref$dropdownOptions = _ref.dropdownOptions,
      dropdownOptions = _ref$dropdownOptions === void 0 ? [] : _ref$dropdownOptions,
      _ref$dropdownCell = _ref.dropdownCell,
      dropdownCell = _ref$dropdownCell === void 0 ? false : _ref$dropdownCell,
      rowClassName = _ref.rowClassName,
      _ref$dropdownMode = _ref.dropdownMode,
      dropdownMode = _ref$dropdownMode === void 0 ? 'row-click' : _ref$dropdownMode,
      cellToShowDropdown = _ref.cellToShowDropdown,
      selectedRowDropdown = _ref.selectedRowDropdown,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      _ref$dataList = _ref.dataList,
      dataList = _ref$dataList === void 0 ? [] : _ref$dataList,
      _ref$onSelectDropdown = _ref.onSelectDropdownOption,
      onSelectDropdownOption = _ref$onSelectDropdown === void 0 ? _noop2.default : _ref$onSelectDropdown,
      _ref$onDimmerClick = _ref.onDimmerClick,
      onDimmerClick = _ref$onDimmerClick === void 0 ? _noop2.default : _ref$onDimmerClick,
      _ref$onAddElementToDr = _ref.onAddElementToDropdown,
      onAddElementToDropdown = _ref$onAddElementToDr === void 0 ? _noop2.default : _ref$onAddElementToDr;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDropdown = _useState2[0],
      setShowDropdown = _useState2[1];

  var rowRef = (0, _react.useRef)({});
  var dropdownContainerRef = (0, _react.useRef)(null);
  var popoverPropsRef = (0, _react.useRef)(null);
  var isRowClick = dropdownMode === 'row-click';
  var isPointClick = dropdownMode === 'points-click';

  var handleMouseHover = function handleMouseHover() {
    return setShowDropdown(true);
  };

  var handleMouseLeave = function handleMouseLeave() {
    return setShowDropdown(false);
  };

  var handleDimmer = function handleDimmer() {
    onDimmerClick.apply(void 0, arguments);
    setShowDropdown(false);
  };

  var handleRowClick = function handleRowClick(rowData) {
    var rowToOpenDropdown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return function () {
      if (!rowRef.current.stopPropagation) {
        rowClick(rowData);

        if (dropdownCell && isRowClick && !(0, _isEmpty2.default)(popoverPropsRef.current)) {
          onAddElementToDropdown(rowToOpenDropdown);
          popoverPropsRef.current.onTriggerClick();
        }
      } else if (rowRef.current) {
        rowRef.current.stopPropagation = false;
      }
    };
  };

  return /*#__PURE__*/_react.default.createElement("tr", {
    ref: rowRef,
    tabIndex: "0",
    onClick: handleRowClick(data, selectedRowDropdown ? null : rowKey),
    onMouseMove: handleMouseHover,
    onMouseLeave: handleMouseLeave,
    className: (0, _classnames.default)(rowClassName)
  }, columns.map(function (col, i) {
    var field = col.field,
        Cell = col.renderer;
    var cellKey = field + rowKey;
    var value = (0, _get2.default)(data, field);
    var cellWithDropdown = i === 0 && dropdownCell;
    var keyToValueDropdown = isRowClick ? rowKey : cellKey;
    var selectedDropdown = cellToShowDropdown === keyToValueDropdown;

    var handleAction = function handleAction() {
      if (isPointClick) {
        rowRef.current.stopPropagation = true;
        onAddElementToDropdown(selectedDropdown ? null : keyToValueDropdown);
      }
    };

    var handleSelectOption = function handleSelectOption(values) {
      onSelectDropdownOption(values, data);
      setShowDropdown(false);
    };

    return /*#__PURE__*/_react.default.createElement(Cell, {
      key: cellKey,
      value: value,
      data: data,
      dataList: dataList,
      valueClassName: (0, _classnames.default)(cellWithDropdown && showDropdown ? 'pl-5 ml-2 overflow-auto' : 'px-2 mx-1 overflow-auto'),
      column: col
    }, function (props) {
      var menuItems = props.dropdownOptions || dropdownOptions;
      var withMenuItems = menuItems && menuItems.length > 0;

      var renderIcon = function renderIcon(popoverProps) {
        popoverPropsRef.current = popoverProps;
        return /*#__PURE__*/_react.default.createElement("button", {
          ref: popoverProps.trigger,
          onClick: isPointClick ? popoverProps.onTriggerClick : _noop2.default,
          type: "button",
          className: "bg-white w-3 flex items-center"
        }, /*#__PURE__*/_react.default.createElement(_Icons.Circles, {
          width: ".5rem"
        }));
      };

      if (!showDropdown) return null;
      return cellWithDropdown && withMenuItems && /*#__PURE__*/_react.default.createElement("div", {
        className: "absolute px-2 -mt-1",
        onClick: handleAction,
        onKeyPress: handleAction,
        role: "button",
        tabIndex: "-1",
        ref: dropdownContainerRef
      }, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
        icon: renderIcon,
        options: menuItems,
        onSelectOption: handleSelectOption,
        onDimmerClick: handleDimmer
      }));
    });
  }), removeItem && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "RemoveItemButton",
    type: "button",
    onClick: function onClick() {
      return onRemoveItem(data);
    },
    onKeyPress: function onKeyPress() {
      return onRemoveItem(data);
    },
    tabIndex: "0",
    role: "button"
  }, /*#__PURE__*/_react.default.createElement(_Icons.IcoDeleteGray, {
    width: "1.5rem",
    height: "1.5rem"
  }))));
}

BodyRow.propTypes = {
  id: _propTypes.default.any.isRequired,
  columns: _propTypes.default.array.isRequired,
  rowClick: _propTypes.default.func,
  rowClassName: _propTypes.default.string,
  removeItem: _propTypes.default.bool,
  selectedRowDropdown: _propTypes.default.bool,
  cellToShowDropdown: _propTypes.default.any,
  onRemoveItem: _propTypes.default.func,
  dropdownOptions: _propTypes.default.array,
  dropdownCell: _propTypes.default.bool,
  dropdownMode: _propTypes.default.string,
  data: _propTypes.default.object,
  dataList: _propTypes.default.array,
  onSelectDropdownOption: _propTypes.default.func,
  onDimmerClick: _propTypes.default.func,
  onAddElementToDropdown: _propTypes.default.func
};